declare var d3: any;

import { Injectable } from '@angular/core';
import '../../assets/libs/d3.v3.min.js';

@Injectable()
export class StatsService {


  constructor() { }

  buildLineChartOffers(input){

    var width = 260;
    var height = 100;

    var parseDate = d3.time.format("%Y-%m-%d").parse;

    var data = [];
    for (var i=0; i<input.length; i++){
      if (input[i].client && input[i].client != 19){
        var d_date = input[i].created.substring(0, 10);
        var obj = {
          d: parseDate(d_date),
          n: 1
        }
        data.push(obj);
      }
    }

    var dict = {};

    for (var i=0; i<data.length; i++){
      if (!dict[data[i].d])
        dict[data[i].d] = 1;
      else
        dict[data[i].d] = dict[data[i].d] + 1;
    }

    data = [];
    var keys = Object.keys(dict);
    for (var i=0; i<keys.length; i++) {
       obj = {
        d: new Date(keys[i]),
        n: parseInt(dict[keys[i]])
      }
      data.push(obj);
    }

    var max = d3.max(data, function(d) { return d.n; });
	  var minDate = d3.min(data, function(d) {return d.d; });
		var maxDate = d3.max(data, function(d) { return d.d; })

    var y = d3.scale.linear()
					.domain([0,max])
					.range([height,0]);

		var x = d3.time.scale()
					.domain([minDate,maxDate])
					.range([0,width]);

		var yAxis = d3.svg.axis()
						.orient("left")
            .ticks(5, "f")
						.scale(y);

		var xAxis = d3.svg.axis()
						.orient("bottom")
            .ticks(5, "f")
						.scale(x);

		var line = d3.svg.line()
			.x(function(d){ return x(d.d); })
			.y(function(d){ return y(d.n); })
			.interpolate("cardinal");


    var svg = d3.select("#statsline").append("svg").attr("id","svg").attr("height","100%").attr("width","100%");

    var chartGroup = svg.append("g").attr("class","chartGroup").attr("transform","translate("+35+","+10+")");

    chartGroup.append("path")
    			.attr("class","line")
    			.attr("d",function(d){ return line(data); })

    chartGroup.append("g")
    			.attr("class","axis x")
    			.attr("transform","translate(0,"+(height)+")")
    			.call(xAxis);

    chartGroup.append("g")
    			.attr("class","axis y")
    			.call(yAxis);

  }

  buildLineChartUsers(input){

    var width = 260;
    var height = 100;

    var parseDate = d3.time.format("%Y-%m-%d").parse;

    var data = [];
    for (var i=0; i<input.length; i++){
        var d_date = input[i].date_joined.substring(0, 10);
        data.push(d_date);
    }

    var dict = {};

    for (var i=0; i<data.length; i++){
      if (!dict[data[i]])
        dict[data[i]] = 1;
      else
        dict[data[i]] = dict[data[i]] + 1;
    }

    data = [];
    var keys = Object.keys(dict);
    for (var i=0; i<keys.length; i++) {
       var obj = {
        d: new Date(keys[i]),
        n: parseInt(dict[keys[i]])
      }
      data.push(obj);
    }

    for (var i=0; i < data.length - 1; i++) {
      data[i+1].n = data[i+1].n + data[i].n;
    }

    var max = d3.max(data, function(d) { return d.n; });
	  var minDate = d3.min(data, function(d) {return d.d; });
		var maxDate = d3.max(data, function(d) { return d.d; });

    var y = d3.scale.linear()
					.domain([0,max])
					.range([height,0]);

		var x = d3.time.scale()
					.domain([minDate,maxDate])
					.range([0,width]);

		var yAxis = d3.svg.axis()
						.orient("left")
            .ticks(5, "f")
						.scale(y);

		var xAxis = d3.svg.axis()
						.orient("bottom")
            .ticks(5, "f")
						.scale(x);

		var line = d3.svg.line()
			.x(function(d){ return x(d.d); })
			.y(function(d){ return y(d.n); })
			.interpolate("cardinal");


    var svg = d3.select("#statsline2").append("svg").attr("id","svg").attr("height","100%").attr("width","100%");

    var chartGroup = svg.append("g").attr("class","chartGroup").attr("transform","translate("+35+","+10+")");

    chartGroup.append("path")
    			.attr("class","line")
    			.attr("d",function(d){ return line(data); })

    chartGroup.append("g")
    			.attr("class","axis x")
    			.attr("transform","translate(0,"+(height)+")")
    			.call(xAxis);

    chartGroup.append("g")
    			.attr("class","axis y")
    			.call(yAxis);

  }


}



// WEBPACK FOOTER //
// ./src/app/account/stats.service.ts